<template>
  <b-form
    @submit="
      evt => {
        evt.preventDefault();
        $emit('onSubmit', this.form);
      }
    "
  >
    <b-row>
      <b-col md="4">
        <b-form-group label="Review Session" label-for="id-session">
          <v-select
            inputId="id-session"
            v-model="form.reviewSessionId"
            :options="rwSessions"
            :reduce="({ id }) => id"
            label="period"
          >
            <template #option="{ status, period }">
              <b-badge :variant="statusToVariant(status)">{{ status }}</b-badge>
              {{ period }}
            </template>
          </v-select>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group label="Target" label-for="id-user">
          <v-select inputId="id-user" v-model="form.target" :options="users" :reduce="({ id }) => id" label="name" />
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group label="Group Criteria" label-for="id-g-criteria">
          <v-select
            inputId="id-g-criteria"
            v-model="form.groupCriteriaId"
            :options="groupCriteria"
            :reduce="({ id }) => id"
            label="name"
          />
        </b-form-group>
      </b-col>
      <b-col md="12" class="crf-submit">
        <Button :disabled="!form.reviewSessionId || !form.groupCriteriaId || !form.target">Create Form</Button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import Button from '@/components/Button';
import { statusToVariant } from '@/constants';

export default {
  name: 'CreateReviewForm',
  components: { Button },
  data() {
    const form = {
      reviewSessionId: null,
      target: null,
      groupCriteriaId: null,
    };

    if (this.rwSessions.length == 1) form.reviewSessionId = this.rwSessions[0].id;
    if (this.users.length == 1) form.target = this.users[0].id;
    if (this.groupCriteria.length == 1) form.groupCriteriaId = this.groupCriteria[0].id;

    return {
      form,
    };
  },
  props: {
    rwSessions: {
      type: Array,
      default() {
        return [];
      },
    },
    users: {
      type: Array,
      default() {
        return [];
      },
    },
    groupCriteria: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    statusToVariant,
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/colors.scss';

form {
  background-color: $gray;
  padding: 2rem 4rem;
  margin-bottom: 4rem;
  border-radius: 0.5rem;
  border: 1px solid #d0d1d2;
}

button {
  background-color: $darkBlue !important;
  outline: none;
  border: none;
  font-size: 1.6rem;
  opacity: 1 !important;
}
</style>
